<div class="col-md-12 mb-30" [hidden]="Selected_PM_Record_Switcher!='List'">
  <div class="card card-statistics h-100">
    <div class="card-body">
     <h5 class="card-title border-0 pb-0" *ngIf="inner_PM_Item_Record.id==0">Header List</h5>
     <h5 class="card-title border-0 pb-0" *ngIf="inner_PM_Item_Record.id>0"> Header Details '{{inner_PM_Item_Record.title}}'</h5>
     <br/>
     <br/>

     <div class="row">
      <div class="form-group col-md-4">
        <label for="exampleInputEmail1">Title</label>
        <input [(ngModel)]="Filter_Title" (keyup)="Change_Filter()" name="Filter_Title" type="text" class="form-control"  placeholder="Type here to search...">
      </div>

    </div>
     <div class="row">
      <div  class="form-group col-md-6" >
        <button *ngIf="!Procssing" type="button" (click)="ReadData_PM()"  class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
        <button *ngIf="!Procssing" (click)="Set_Form_PM_View_Add()" type="button"  class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Add New Record </button>
        <button *ngIf="!Procssing && inner_PM_Item_Record.id>0" (click)="ReSet_Inner_PM_Item_Record()" type="button"  class="btn btn-warning" style="margin-right: 5px;"><i class="fa fa-mail-reply"></i> Back to Headers</button>
        <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
      </div>
     </div>
      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Title</th>
              <th>Status</th>
              <th>Created By</th>
              <th>Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_PM
            |filter:Filter_Title:'title'
            | paginate
                    : {
                        id: 'DataList_PMTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: (DataList_PM
                        |filter:Filter_Title:'title'
                        ).length
                      }
            ">
             <td>{{DataList_PM.indexOf(item)+1}}</td>
              <td>{{item.title}}</td>
              <td>
                <p *ngIf="!item.del" style="color: #489b39;">Active</p>
                <p *ngIf="item.del" style="color: crimson;">Inactive</p>
              </td>
              <td>{{item.creater}}</td>
              <td>{{item.persianDate}}</td>
              <td>
                <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                  <div *ngIf="!item.DeletingProccess" class="btn-group" role="group">
                      <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          Actions
                      </button>
                      <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">

                          <a style="cursor: pointer;" *ngIf="inner_PM_Item_Record.id==0" class="dropdown-item" (click)="Set_Inner_PM_Item_Record(item)"><i class="fa fa-eye"></i> View Child Level </a>
                          <a style="cursor: pointer;" class="dropdown-item" (click)="Set_Form_PM_View(item,'Form')"><i class="fa fa-edit"></i> Edit </a>

                          <a *ngIf="item.del==false" style="cursor: pointer;" class="dropdown-item" (click)="openModal(template,item)"><i class="fa fa-lock"></i> Inactive </a>
                          <a *ngIf="item.del==true" style="cursor: pointer;" class="dropdown-item" (click)="openModal(template,item)"><i class="fa fa-unlock"></i> Active </a>
                      </div>
                  </div>

                  <div *ngIf="item.DeletingProccess" >
                    <img  src="assets/Loading.gif" style="width: 25px;" />
                  </div>
              </div>
              </td>

            </tr>
          </tbody>
        </table>
     </div>
    </div>
    <pagination-controls
     id="DataList_PMTable"
     nextLabel="Next"
     previousLabel="Previous"
     (pageChange)="page = $event"
   ></pagination-controls>
  </div>
</div>

<div  class="col-md-12 mb-30" *ngIf="Selected_PM_Record_Switcher=='Form'">
  <app-PMItemForm
  [inner_PM]="Selected_PM_Record"
  [inner_Parent]="inner_PM_Item_Record.id"
    >
  </app-PMItemForm>

  <button (click)="Set_List_PM_View()" type="button" class="btn btn-warning"><i
    class="fa fa-mail-reply"></i> Back </button>

</div>

<ng-template #template>
  <div class="modal-header">
    <h4 *ngIf="Data_Seleted_Delete.del==false" class="modal-title pull-left">Approve Deactivate
      '{{Data_Seleted_Delete.title}}' </h4>
    <h4 *ngIf="Data_Seleted_Delete.del==true" class="modal-title pull-left">Approve Activate
      '{{Data_Seleted_Delete.title}}' </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Delete.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-footer">
    <button *ngIf="Data_Seleted_Delete.del==false" type="button" class="btn btn-warning"
      (click)="Delete(Data_Seleted_Delete)"> Deactivate <i class="fa fa-lock"></i></button>
    <button *ngIf="Data_Seleted_Delete.del==true" type="button" class="btn btn-warning"
      (click)="Delete(Data_Seleted_Delete)"> Activate <i class="fa fa-unlock"></i></button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Delete.hide()">Close</button>
  </div>
</ng-template>

